import React, {Component} from 'react';
import {Row,Col,Modal,Form} from 'react-bootstrap';
import {ContentDiv, BodyHeaderDiv, BodyHeaderText, SubmitBtn} from '../../theme/MorsTheme';
import {changePasswordExpired} from '../../Utilities/WSUtil';
import {USERDATA}from '../../resources/constant.js';
import renderHTML from 'react-render-html';

class ExpPassword extends Component {

    constructor(props) {
        super(props);              
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        

        this.state = {
            show: false,
            changePassword: 'Change Password',            
            fetchMessage: '',
            loginValidated: false,
            forgotPasswordValidated: false,
            forgotPasswordResponse: '',
            forgotPasswordStatus:false,
            showExclamation:false,
            userName:'',
            password:'',
            userId:'',
            userData: JSON.parse(localStorage.getItem(USERDATA)),
                    
          };   
    }
    

    componentDidMount(){        
        this.setState({
            fetchMessage:'',
            showExclamation:false,
            forgotPasswordResponse:'',
            userData: JSON.parse(localStorage.getItem(USERDATA))})        
    }

    handleClose(event) {
        //event.preventDefault();      
        this.setState({ 
            show: false,    
            fetchMessage: '',            
        });        
        this.props.expPwdLogout(this.state.userData.l);

      }

    handleShow(event){       
        event.preventDefault();       
        this.setState({ show: true, userId:'' });         
    }
    
    handleChange(e){                        
        this.setState(
            {                
                [e.target.id]: e.target.value
            }
        )
    }    

    handleSubmit(event) {        
        event.preventDefault();                  
        event.stopPropagation();
        this.setState({
            fetchMessage: 'Waiting for response...'
        })             
        changePasswordExpired(this.state.userData.loginName, this.state.currentPassword, this.state.newPassword, this.state.confirmPassword)        
        .then(response => {
            this.setState({
                show: true,
                fetchMessage: response.message
            })    

        }).catch(err => {
            this.setState({
                fetchMessage: err.message
            })    
        })
         
    }
    render() {                
        return(      
            <div>
            <BodyHeaderDiv>
                    <BodyHeaderText>Change Password</BodyHeaderText>
            </BodyHeaderDiv>
            <ContentDiv>
            <Row>

                <Col>
                    
                    <Row>
                    <Col md={4}></Col>                
                <Col md={4}>
                <Form onSubmit={this.handleSubmit}>                          
                    <Form.Label size='sm' style={{fontWeight:'bold'}}>Current Password</Form.Label>
                    <Form.Row>                        
                        <Form.Group as ={Col} controlId="currentPassword" onChange={this.handleChange} onBlur={this.blurChange}>                                                
                            <Form.Control maxLength={12} size='sm' type="password" value={this.state.currentPassword} disabled={this.state.checkedAllReport}></Form.Control>                                                                            
                        </Form.Group>                                
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="newPassword" onChange={this.handleChange}>
                            <Form.Label size='sm' style={{fontWeight:'bold'}}>New Password</Form.Label>
                            <Form.Control type="password"  size='sm' maxLength={12}></Form.Control>
                        </Form.Group>
                    </Form.Row>

                    <Form.Label size='sm' style={{fontWeight:'bold'}}>Confirm Password</Form.Label>
                    <Form.Row>
                        <Form.Group as={Col} controlId="confirmPassword" onChange={this.handleChange}>                            
                            <Form.Control type="password" size='sm' maxLength={12}></Form.Control>                            
                        </Form.Group>                        
                    </Form.Row>   

                    <div style={{lineHeight:'0.8750em'}}>
                        <span style={{fontSize:"10px",color:"red"}}>
                        <b> Note:</b> Password should be at least 8 <br/>
                        characters, alphanumeric, combination of <br/> uppercase and lowercase and with special <br/>character.
	                    </span>
                    </div>

                    <div align="center" style={{paddingTop:'16px', paddingBottom:'16px'}}>
                    <SubmitBtn style={{color:'#FFFFFF'}}>Save</SubmitBtn>                                                                         
                    </div>

                    <div style={{color:'red', marginTop:'12px',  fontSize:'12px'}}>        
                        {renderHTML(this.state.fetchMessage)}    
                    </div> 

                </Form>  
                    </Col>
                    <Col md={4}>
                    </Col>


                    </Row>
                </Col>
                
                </Row>


                <Modal dialogClassName="modal-bdo" show={this.state.show} backdrop={'static'}  onHide={this.handleClose} centered={true} backdropClassName='fade'>                
                    <Modal.Header style={{backgroundColor:'#0B2972', height:'40px', padding:'15px, 0px'}}>                      
                        <Modal.Title style={{fontSize:'14px', color:'white'}}><span>Change Password Confirmation</span></Modal.Title>
                    </Modal.Header>
                    <Modal.Body >    
                        
                    <div align="center" style={{marginTop:'12px',  fontSize:'12px'}}>        
                        {renderHTML(this.state.fetchMessage)}    
                    </div> 
                                                                 
                        <div align="center" style={{marginTop:'10px'}}>    
                            <SubmitBtn onClick={this.handleClose}>OK</SubmitBtn>                                         
                            
                        </div>                                         
                    
                    </Modal.Body>                                                               
                </Modal> 
                
                </ContentDiv>             


                         
            </div>       
        )                
    }
}

export default ExpPassword;